/** @format */
import { isEmpty, isNumber, isUndefined } from 'lodash';

/**
 * Utility for checking a value is defined and is not empty
 *
 * @param value A value
 * @return {Boolean}
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const hasValue = (value: any): boolean => {
    return (!isUndefined(value) && !isEmpty(value)) || isNumber(value);
};

export function isObject(variable: any) {
    return (
        typeof variable === 'object' &&
        variable !== null &&
        !Array.isArray(variable)
    );
}
